import React, { KeyboardEventHandler, MouseEventHandler } from "react";

import cx from "classnames";

import styles from "./Dropdown.scss";
import { DropdownOption } from "./DropdownOption";
import { DropdownOptionType } from "./types";

interface DropdownListProps<T extends string | number | boolean> {
  dropdownMenuId: string;
  dropdownTriggerId: string;
  menuKeyDownHandler: KeyboardEventHandler<HTMLUListElement>;
  menuMouseEnterHandler: MouseEventHandler<HTMLUListElement>;
  options: DropdownOptionType<T>[];
  selectedOptionValue: string | number | boolean | undefined;
  highlightedIndex: number;
  onOptionSelect: (option: DropdownOptionType<T>) => void;
  selectedLabel: string;
  isOpen: boolean;
  listContainerClassname?: string;
}

export function DropdownList<T extends string | number | boolean>({
  dropdownMenuId,
  dropdownTriggerId,
  menuKeyDownHandler,
  menuMouseEnterHandler,
  options,
  selectedOptionValue,
  highlightedIndex,
  onOptionSelect,
  selectedLabel,
  isOpen,
  listContainerClassname,
}: DropdownListProps<T>) {
  const listContainerClasses = cx(
    styles["dropdown-list"],
    listContainerClassname
  );

  return (
    <ul
      id={dropdownMenuId}
      className={listContainerClasses}
      role="listbox"
      aria-labelledby={dropdownTriggerId}
      onKeyDown={menuKeyDownHandler}
      onMouseEnter={menuMouseEnterHandler}
      data-testid="dropdown-list"
      aria-expanded={isOpen}
    >
      {options.map((option, optionIndex) => (
        <li
          key={String(option.value)}
          role="none"
          data-testid={`dropdown-list-option-${optionIndex}`}
        >
          <DropdownOption
            option={option}
            selected={selectedOptionValue === option.value}
            highlighted={highlightedIndex === optionIndex}
            onSelect={onOptionSelect}
            selectedLabel={selectedLabel}
          />
        </li>
      ))}
    </ul>
  );
}
